import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  
  if (user === null) {
    return (
      <div className="bg-primary min-h-screen flex items-center justify-center">
        <div className="text-white/30 font-body text-sm tracking-widest uppercase">Loading...</div>
      </div>
    );
  }
  
  if (user === false) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }
  
  return children;
}
